export const onboarding = {
  skip: 'Skip',
  back: 'Back',
  close: 'Close',
  next: 'Next',
  finish: 'Finish'
};
